module.exports = __webpack_public_path__ + "img/picto-operateur-egal.3fdd8113.svg";